(function($) {

  var $qtyBtnTrigger = $('.js-enable-qty-trigger');
  var $qtyBtn = $('.js-btn-qty');
  var $priceCtrl = $('.js-mbl-price-ctrl');

  $qtyBtnTrigger.click(function(){
    $(this).hide();
    $qtyBtn.css({'display': 'flex', 'justify-content': 'space-around'});
    $qtyBtn.find('.minus').focus();
    $priceCtrl.show();
  });


  /********
   !!! 
   THIS PART IS NOW 
   in file _ src/views/01-atoms/ctas/button/button--qty.js _ 
   leave here commented for future references
   !!!
  ********/
  
  // // MANAGE BUTTON/INPUT ADD/REMOVE VIP LOUNGE
  // var qtyValue = $('#vip_lounge_qty');
  // var addBtn = $('.js-toggle-add');
  // var removeBtn = $('.js-toggle-remove');
  // var icon = $('#icon_toggle_lounge');
  // var parkTooltip = $('#tooltip_toggle_lounge');

  // // increase value
  // addBtn.click(function() {
  //   $(removeBtn).prop('disabled', false);
  //   $(parkTooltip).removeClass('active');
  //   $(icon).addClass('active');
  //   $(qtyValue).val(function(i, oldval) {
  //     return ++oldval;
  //   })
  // });

  // // decrease value
  // removeBtn.click(function() {
  //   $(qtyValue).val(function(i, oldval) {
    
  //   if (oldval >= 1) {
  //     if (oldval <= 1) {
  //       $(removeBtn).prop('disabled', true);
  //       $(parkTooltip).addClass('active');
  //       $(icon).removeClass('active');
  //     }
  //     return --oldval;
  //   }

  //   })
  // });
})(jQuery);